export const screens = [
    {
        col: 1,
        row: 1,
        total: 1,
    },
    {
        col: 2,
        row: 2,
        total: 4,
    },
    {
        col: 3,
        row: 2,
        total: 6,
    },
    {
        col: 4,
        row: 2,
        total: 8,
    },
    {
        col: 3,
        row: 3,
        total: 9,
    },
    {
        col: 5,
        row: 2,
        total: 10,
    },
    {
        col: 4,
        row: 4,
        total: 16,
    },
    {
        col: 5,
        row: 5,
        total: 25,
    },
    {
        col: 6,
        row: 6,
        total: 36,
    },
    {
        col: 7,
        row: 7,
        total: 49,
    },
    {
        col: 8,
        row: 8,
        total: 64,
    },
]